import { render } from "./ColetaFormView.vue?vue&type=template&id=8b55d648"
import script from "./ColetaFormView.vue?vue&type=script&lang=js"
export * from "./ColetaFormView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__